import { useViewer } from '@vimeo/viewer';

import { CampaignIdOverride } from '../context/default-settings';
import { useOrionSettings } from '../hooks/useOrionSettings';

const REPACKAGING_CAMPAIGN_KEYS: CampaignIdOverride[] = ['rp_2026', 'rp_2026_strict'];

const CAMPAIGNS_MAP: Record<NonNullable<CampaignIdOverride>, string> = {
  ['pi_2026_storage_seat']: '01KG096VQ3VBDVSPHGCF4JQS1F',
  ['pi_2026_legacy_plans']: '01KG799DF3ZBKYB4MSGHKXAM4Z',
  ['rp_2026']: '01KGEWQ5SAS6NW735YSBYK68XG',
  ['rp_2026_strict']: '01KGPR56B56Z9H89TBNS98ASMT',
} as const;

export const REPACKAGING_CAMPAIGN_IDS = REPACKAGING_CAMPAIGN_KEYS.map((key) => CAMPAIGNS_MAP[key]);

const getCampaignIdOverride = (campaignIdOverride: 'null' | CampaignIdOverride) => {
  if (
    campaignIdOverride &&
    campaignIdOverride !== 'null' &&
    CAMPAIGNS_MAP.hasOwnProperty(campaignIdOverride)
  ) {
    return CAMPAIGNS_MAP[campaignIdOverride];
  }
  return null;
};

export const useCampaignIdOverride = () => {
  const { settings } = useOrionSettings();
  const viewer = useViewer();

  let campaignIdOverride = settings.campaign_id_override;
  if (campaignIdOverride === 'pi_2026') {
    const tier = viewer.teamUser?.accountType?.toString() ?? viewer.user?.account?.toString() ?? '';
    // Note: we're falling back to storage seat plans if the user is not a legacy tier
    campaignIdOverride = isLegacyTier(tier) ? 'pi_2026_legacy_plans' : 'pi_2026_storage_seat';
  }

  return getCampaignIdOverride(campaignIdOverride);
};

const isLegacyTier = (tier: string) => {
  const LEGACY_TIERS = [
    'basic',
    'plus',
    'pro',
    'pro_unlimited',
    'pro_custom',
    'business',
    'live_business',
    'live_pro',
    'live_premium',
  ];
  return LEGACY_TIERS.includes(tier);
};
